import React, { useState } from "react";
import "./Hero.css";
import Insigne from "../../assets/imgs/insigne-marca (1).webp";

const CTA = () => {
  return (
    <div className="cta-wrapper">
      <div className="cta-container">
        <div className="home-text">
          <h4>Seja Insigne</h4>

          <h1>Editora Insigne Acadêmica</h1>

          <p className="mb-2">
            Com Conselho Editorial composto por professores doutores, de diversas áreas do conhecimento, nacionais e estrangeiros, <span>
              a Editora Insigne Acadêmica fará todo o
              acompanhamento e registro de sua obra.
            </span>
          </p>
{/* 
          <p>
            Inclusive, além de digital, seu livro poderá ser impresso para fazer
            lançamentos, para presentear ou para colocar na sua estante.
          </p> */}

          <p className="mb-2">
            Aqui, você será conhecido por suas obras e feitos. Aqui, você será
            Insigne.
          </p>

          <a
            href="https://wa.link/o4jzw4"
            target="_blank"
            rel="noreferrer"
            alt="link para mentoria"
            className="main-btn mt-3"
          >
            publique conosco!
          </a>
        </div>
        <div className="cta-img">
          <img src={Insigne} alt="logo"></img>
        </div>
      </div>
    </div>
  );
};

export default CTA;
